module.exports = __webpack_public_path__ + "media/images/components/c15-error-message/questionmark-fd0a3e3f39911585d82100005b3a3b71.svg";